import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {
    Table,
    Button,
    LightTextButton,
    FilterDropdown,
    SwitchButton,
    ImageStamp,
    TextLink,
    TextInput,
    Status,
    Search
} from "components";
import {customersAction, classSessionAction} from "redux/actions";
import EditClassSessionPopup from "../popups/Routing/EditClassSessionPopup";
import UserClassSessionPopup from "../popups/Routing/UserClassSessionPopup";
import {useHistory, useLocation} from "react-router-dom";
import * as XLSX from "xlsx";
import {Modal} from "@material-ui/core";
import ReportModal from "../../Report/ReportModal";
import MemberProfileDetailsModal from "../../Report/MemberProfileDetailsModal";
import {adminToken} from "../../../helper";
import axios from "axios";
import {AWS_URL_UM_INT_8089, AWS_SERVER_APIS} from "../../../configurations";
// import MemberProfileDetailsModal from "../modals/MemberProfileDetailsModal";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";
// import UpdateGrandAPPSeniorModel from "../modals/UpdateGrandAPPSeniorModel";

const initialState = {
    id: "",
    package_id: "",
    sp_id: "",
    sub_category_id: "",
    package_name: ""
};

export default function ClassSessionsPanel() {
    // Routers
    const {push, location} = useHistory();

    const [openModal, setOpenModal] = useState(false)
    const [refreshPage, setRefreshPage] = useState(null)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [openCusModal, setOpenCusModal] = useState(false)

    const handleCloseCusModal = () => {
        setOpenCusModal(false)
    }

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    const [clickedCustomer, setClickedCustomer] = useState(null)
    const [clickedElder, setClickedElder] = useState(null)
    const [clickedSubscription, setClickedSubscription] = useState(null)
    const [openModalUpdateSenior, setOpenModalUpdateSenior] = useState(false);

    const handleOpenModalUS = () => {
        setOpenModalUpdateSenior(true)
    }
    const handleCloseUS = () => {
        setOpenModalUpdateSenior(false)
    }

    // Query based filter
    const locationSearch = useLocation().search;
    const query = new URLSearchParams(locationSearch);
    const userID = 1;//query.get("userID");

    // States
    const [tableRows, setTableRows] = useState();
    const [editableDetail, setEditableDetails] = useState();
    const [isPopupVisible, setPopupVisible] = useState();
    const [isUserPopupVisible, setUserPopupVisible] = useState();

    // const [filterState, setFilterState] = useState(false)

    // Filter States
    const [status, setStatus] = useState();
    const [filterState, setfilterState] = useState(initialState);
    const [activeStatus, setActiveStatus] = useState(11);
    const [randomkey, setRandomkey] = useState(0);
    

    // Redux actions
    const dispatch = useDispatch();
    const {customers, classSession, userRole} = useSelector(state => ({
        customers: state.customers,
        classSession: state.classSession,
        userRole: state.userRole?.filter(role => role.module === "Lifestyle Sessions")
    }));


    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read"))
            dispatch(classSessionAction.get());
            // dispatch(customersAction.get(1));
        return () => dispatch(classSessionAction.reset());
    }, [activeStatus]);

    // const onPageChange = e => dispatch(customersAction.get(e));
    const onPageChange = e => dispatch();

    const handleOpenCusModal = (fname) => {
        console.log(JSON.stringify(filterState));
        dispatch(
            customersAction.search({
                pageNumber: 1,
                query: fname
            })
        )
        setOpenCusModal(true)
    }

    const onChange = e => setfilterState({...filterState, [e.target.name]: e.target.value});

    // internal search
    const internalSearch = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;

        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item[searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    // internal search for user details sub arrsy
    const internalSearchUser = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;
        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item['get_user'][searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    const handleUpdateStatus = async (classId) => {
        let result = window.confirm('Are you sure?');
        if(result){
            await dispatch(classSessionAction.toggleclass(classId));
            setTimeout(() => {
                setActiveStatus(Math.floor(Math.random() * 100));
            },1000)
        }        
    };

    useEffect(() => {
        // if (!classSession?.length) {
        //     setTableRows();
        //     return;
        // }

        let filtered = classSession;
        
        if (userRole?.find(item => item.privilege === "Read")){
            filtered = internalSearch("id", filtered);
            filtered = internalSearch("package_id", filtered);
            filtered = internalSearch("sub_category_id", filtered);
            filtered = internalSearch("sp_id", filtered);
            // filtered = internalSearch("package_name", filtered);
            //filtered = internalSearchUser("package_name", filtered);
        }
        
        // console.log(JSON.stringify(filtered));
        let newData = [];
        // Map table rows
        filtered?.forEach(obj => {
            const data = {
                id: obj?.id,
                package_id: obj?.get_package?.package_name,
                class_date: obj?.class_date,
                class_time: obj?.class_time,
                sp_id: obj?.sp_id,
                sp_name: (obj?.get_s_p?.first_name)?obj?.get_s_p?.first_name+' '+obj?.get_s_p?.last_name:'',
                sp_mobile: obj?.get_s_p?.mobile,
                join_url: (
                            <TextLink
                                    text={obj?.join_url}
                                    onClick={() =>
                                        window.open(
                                            `${obj?.join_url}`,
                                            "_blank"
                                        )
                                    }
                                />
                        ),
                status: obj?.status,
                sub_category_id: obj?.sub_category_id,
                // package_name: obj?.package_name,
                // package_image_url: obj?.package_image_url,
                createdAt: `${new Date(obj?.created_at).toLocaleString()}`,
                updatedAt: `${new Date(obj?.updated_at).toLocaleString()}`,
                enabled: <a href="javascript:void(0);" onClick={
                                        userRole?.find(item => item.privilege != "Enable")
                                            ? () => {
                                                handleUpdateStatus(obj?.id);
                                            }
                                            : null
                                    }><Status active={obj?.enabled}/></a>,
                action: (
                    <div style={{"width":118}}>
                        <Button
                            title={'Edit'}
                            style={{"padding":"0 0", "width": "49px", "height":"21px", "font-size":"12px", "margin":"5px"}}
                            onClick={
                                userRole?.find(item => item.privilege === "Read")
                                    ? () => {
                                        setEditableDetails(obj);
                                        setPopupVisible(true);
                                    }
                                    : null
                            }
                        />

                        <Button
                            title={'Users'}
                            style={{"padding":"0 0", "width": "49px", "height":"21px", "background-color":"#49a449","font-size":"12px"}}
                            onClick={
                                userRole?.find(item => item.privilege === "Read")
                                    ? () => {
                                        setEditableDetails(obj);
                                        setUserPopupVisible(true);
                                    }
                                    : null
                            }
                        />
                    </div>
                )
            };
            newData.push(data);
        });

        setTableRows(newData);
    }, [classSession, status, filterState]);

    // Search based on category & sub category name
    const onSearch = () => {
    };

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "ID",
                sortBy: "id"
            },
            {
                title: "Package",
                sortBy: "package_id"
            },
            {
                title: "Class Date",
                sortBy: "class_date"
            },
            {
                title: "Class Time"
            },
            {
                title: "Provider",
                sortBy: "sp_id"
            },
            {
                title: "SP Name",
                sortBy: "sp_name"
            },
            {
                title: "SP Mobile",
                sortBy: "sp_mobile"
            },
            {
                title: "Join URL"
            },
            {
                title: "Status",
                sortBy: "status"
            },
            {
                title: "Sub Category"
            },
            // {
            //     title: "Package Name",
            //     sortBy: "package_name"
            // },
            // {
            //     title: "Package Image URL"
            // },
            {
                title: "Created",
                sortBy: "createdAt"
            },
            {
                title: "Updated",
                sortBy: "updatedAt"
            },
            {
                title: "Enable"
            },
            {
                title: "Action"
            }
        ],
        [tableRows]
    );
    //v2-app
    const exportDataFunc = () => {
        adminToken()
            .then(token =>
                axios.get(
                    `${AWS_SERVER_APIS}/getallclasssessions`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                ).then((response) => {
                        const rows = response.data.data.map(item => {
                            return {
                                "ID": item.id,
                                "Package": item.package_id,
                                "Class Date": item.class_date,
                                "Class Time": item.class_time,
                                "Provider": item.sp_id,
                                "Join URL": item.join_url,
                                "Status": item.status,
                                "Sub Category": item.sub_category_id,
                                "Package Name": item.package_name,
                                "Package Image URL": item.package_image_url,
                                "Created At": item.created_at,
                                "Updated At": item.updated_at
                            }
                        })

                        const worksheet = XLSX.utils.json_to_sheet(rows);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
                        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
                        XLSX.writeFile(workbook, "DataSheet.xlsx");
                    }
                )
            )
    }

    return (
        <div>
            <div className={styles.filter}>
                <TextInput
                    label="ID"
                    name="id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.id}
                />

                <TextInput
                    label="Package"
                    name="package_id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.package_id}
                />
                <TextInput
                    label="Provider"
                    name="sp_id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.sp_id}
                />

                <TextInput
                    label="Sub Category"
                    name="sub_category_id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.sub_category_id}
                />

                {/* <TextInput
                    label="Package Name"
                    name="package_name"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.package_name}
                /> */}

                <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                        onClick={exportDataFunc}
                >Export Data
                </button>

                {/*<LightTextButton onClick={() => setfilterState(initialState)}/>*/}
            </div>
            
            {/* totalPage: Math.ceil(customers?.count / 10) */}

            <Table
                headers={tableHeaders}
                data={tableRows}
                current={classSession?.pageNumber}
                totalPage={0}
                state={filterState !== initialState}
                length={tableRows?.length}
                r_length={classSession?.data?.length}
                t_length={classSession?.count}
                exportData={false}
                // exportDataFunc={exportDataFunc}
            />

            {isPopupVisible && (
                <EditClassSessionPopup
                    data={editableDetail}
                    closeModal={() => setPopupVisible(false)}
                />
            )}

            {isUserPopupVisible && (
                <UserClassSessionPopup
                    data={editableDetail}
                    closeModal={() => setUserPopupVisible(false)}
                />
            )}

        </div>
    );
}
